// Comportement du top menu pendant le scroll
window.addEventListener("scroll", function () {
  const topMenu = document.querySelector(".top-menu");
  if (window.scrollY > 50) {
    topMenu.classList.add("transparent");
  } else {
    topMenu.classList.remove("transparent");
  }
});

// Navigation mobile

document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.getElementById("menu-toggle");
  const mobileMenu = document.querySelector(".header-content-mobile");

  if (toggleButton && mobileMenu) {
    toggleButton.addEventListener("click", function () {
      mobileMenu.classList.toggle("open");
    });
  }
});

document.querySelectorAll(".mobile-nav-menu a").forEach((link) => {
  link.addEventListener("click", () => {
    mobileMenu.classList.remove("open");
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//     const dropdownToggles = document.querySelectorAll(".menu-item-has-children > a");

//     dropdownToggles.forEach(link => {
//       link.addEventListener("click", function (e) {
//         e.preventDefault(); // empêche la redirection
//         const parent = link.parentElement;
//         parent.classList.toggle("open");
//       });
//     });
//   });

document.addEventListener("DOMContentLoaded", function () {
  const toggles = document.querySelectorAll("li.menu-item-has-children > a");

  toggles.forEach((toggle) => {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation(); // ← empêche que les clics se propagent aux parents

      const parentLi = toggle.closest("li.menu-item-has-children");

      // Ferme tous les sous-menus enfants de ce <li> (sous-sous-menus)
      const childOpenItems = parentLi.querySelectorAll(
        "li.menu-item-has-children.open"
      );
      childOpenItems.forEach((child) => {
        if (child !== parentLi) {
          child.classList.remove("open");
        }
      });

      // Toggle le menu actuel
      parentLi.classList.toggle("open");
    });
  });
});
